/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust4_PInputs */

const es_landing_trust4_p = /** @type {(inputs: Landing_Trust4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajamos con clubes y puertos: cuando los barcos navegan, todos ganan.`)
};

const gl_landing_trust4_p = /** @type {(inputs: Landing_Trust4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traballamos con clubes e portos: cando os barcos navegan, todos gañan.`)
};

const en_landing_trust4_p = /** @type {(inputs: Landing_Trust4_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We work with clubs and marinas: when boats sail, everyone wins.`)
};

/**
* | output |
* | --- |
* | "We work with clubs and marinas: when boats sail, everyone wins." |
*
* @param {Landing_Trust4_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust4_p = /** @type {((inputs?: Landing_Trust4_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust4_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust4_p(inputs)
	if (locale === "en") return en_landing_trust4_p(inputs)
	return es_landing_trust4_p(inputs)
});